import React from 'react';
import { Typography, Timeline } from 'antd';
import { CalendarOutlined, ClockCircleOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const DigsPlanWelcome = () => (
  <div>
    <Typography>
      <Title level={2} style={{ textAlign: 'center' }}>
        Thank You for Signing Up for a Digs Plan!
      </Title>
      <Paragraph>
        We're thrilled to welcome you to the Digs family! Here's what's coming
        next as Digs gets started with managing all your home maintenance.
      </Paragraph>

      <Title level={3}>What's Next</Title>
      <Timeline
        items={[
          {
            children: (
              <>
                <Text strong>Setting Up Your Maintenance Calendar</Text>
                <Paragraph>
                  Within <Text strong>2 business days</Text>, our team will
                  reach out to you to start setting up your maintenance calendar
                  customized with the services you’ve chosen.
                </Paragraph>
              </>
            ),
            dot: (
              <ClockCircleOutlined
                style={{
                  fontSize: '16px',
                  color: 'green',
                  backgroundColor: 'transparent',
                }}
              />
            ),
            color: 'blue',
          },
          {
            children: (
              <>
                <Text strong>Scheduling Your First Service</Text>
                <Paragraph>
                  Once your calendar is ready, we’ll schedule your first
                  service. This is typically arranged within{' '}
                  <Text strong>30 days</Text> of activating your plan.
                </Paragraph>
              </>
            ),
            dot: (
              <CalendarOutlined
                style={{
                  fontSize: '16px',
                  color: 'green',
                  backgroundColor: 'transparent',
                }}
              />
            ),
            color: 'green',
          },
        ]}
      />

      <Title level={3}>Install the Digs App</Title>
      <Paragraph>
        Make the most of your Digs Plan by downloading the Digs app! Through the
        app, you'll be able to:
      </Paragraph>
      <ul>
        <li>View your plan details</li>
        <li>Access your maintenance calendar</li>
        <li>Receive updates and more</li>
      </ul>
    </Typography>
  </div>
);

export default DigsPlanWelcome;
